<template>
    <div id="app">
        <step_state></step_state>
        <router-view/>
    </div>
</template>
<script>
    import step_state from './components/StepState'
    export default {
        name: 'app',
        components: {
            step_state,
        },
    }
</script>
<style>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        margin: 60px 0 60px;
        list-style: none;
    }
</style>
